import { toast } from "../../../../core/helpers/message-helper";
import { Row, Col, Card, CardBody, Container } from "reactstrap";
import { useEffect, useState } from "react";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { selectCiudades } from "../../services/solicitudes-soporte-service";
import { useNavigate, useOutletContext } from "react-router-dom";

const CiudadesSolicitudes = () => {
    const { setCiudad } = useOutletContext();
    const [ciudades, setCiudades] = useState([]);
    const navigate = useNavigate();

    useEffect(async () => {
        const resp = await selectCiudades();
        if (!resp.status) return toast.error(resp.message);
        setCiudades(resp.data);
    }, []);

    function onClickCiudad(ciudad) {
        setCiudad(ciudad)
        navigate(
            "/solicitudes/sedes/"
        );
    }

    return (
        <ContentWrapper>
            <div className="d-sm-flex align-items-center justify-content-center mb-4">
                <div className="h3 mb-0 text-purple-mac">
                    <i className="fas fa-city"></i> Ciudad de Soporte
                </div>
            </div>
            <Row>
                {ciudades.map(function (ciudad) {
                    const style = {
                        cursor: "pointer",
                    };
                    return (
                        <Col md="4" key={ciudad.id}>
                            <Container className="row justify-content-center align-items-center">
                                <Card
                                    style={style}
                                    className="border-left-primary shadow h-100 hvr-grow"
                                    onClick={function () {
                                        onClickCiudad(ciudad)
                                    }}
                                >
                                    <CardBody>
                                        <p className="h3 font-weight-bold text-primary text-uppercase mb-2 text-center">
                                            {ciudad.nombre}
                                        </p>
                                        <p className="h5 font-weight-bold text-secondary text-uppercase mb-2 text-center">
                                            {ciudad.departamento}
                                        </p>
                                        <br />
                                        <img
                                            className="rounded-circle"
                                            width="280"
                                            height="280"
                                            src="img/logo_csr_big.png"
                                        />
                                    </CardBody>
                                </Card>
                            </Container>
                        </Col>
                    );
                })}
            </Row>
        </ContentWrapper>
    );
};

export default CiudadesSolicitudes;
